// @flow

import type {MarkdocFragmentRegistration} from 'docs/markdoc';

export const MigratedChunk: MarkdocFragmentRegistration = {
  tag: 'migrated-chunk',
  children: [],
  attributes: {
    was: {
      type: String,
      description:
        "The filename of the partial that used to contain the chunk's content",
    },
    variables: {
      type: Object,
      description:
        "Variable names and values which were replaced in the chunk's content",
    },
  },
};
